let romanVM = null
const mountVm = (vm) => {
  romanVM = vm
}
const destroyVm = () => {
  romanVM = null
}
// 待机动画 map对应动画周期
let standAni = []
// example
// let standAni = [
//   {
//     ani: 'idle',
//     time: 16 * 1000,
//   },
//   {
//     ani: 'Detect',
//     time: 7 * 1000,
//   },
//   {
//     ani: 'crouchingIdle',
//     time: 3 * 1000,
//   },
// ]
const aniMap = {
  idle: 16 * 1000,
  Detect: 7 * 1000,
  crouchingIdle: 3 * 1000,
}

let stopExecution = true // 待机动作,true为停止
let timeoutId = null

/**
 * 保存某个巡检点的待机动作信息
 * @param {*} time 停留时间
 * @param {*} ani 待机动作列表
 */
const initIdleAniInfo = async (ani) => {
  // 停止所有动作
  // const manMixer = await romanVM.player.Native.SkeletonNode.mixer(romanVM.personNode)
  // await romanVM.player.Native.AnimationAction.stopActions(manMixer)
  standAni = []
  if (ani && ani.length === 0) {
    standAni = [
      {
        ani: 'idle',
        time: 16 * 1000,
      },
    ]
    return
  }
  for (let i = 0; i < ani.length; i += 1) {
    const e = ani[i]
    const aniTime = aniMap[e]
    standAni.push({
      ani: e,
      time: aniTime,
    })
  }
}

/**
 * 停止播放所有待机动作
 */
const destroyIdleAniInfo = () => {
  stopExecution = true
}

/**
 * 停止任务，清除下一个任务
 */
const clearNextAni = () => {
  if (timeoutId) {
    clearTimeout(timeoutId)
    timeoutId = null
  }
}

const renderAnimation = async (index) => {
  let beforeIndex = 0
  if (index === 0) {
    beforeIndex = standAni.length - 1
  } else {
    beforeIndex = index - 1
  }
  // 从前一个动作变到后一个动作
  const beforeAni = standAni[beforeIndex].ani
  const afterAni = standAni[index].ani
  // 淡出淡入
  const manMixer = await romanVM.player.Native.SkeletonNode.mixer(romanVM.personNode)
  const beforeClipAction = await romanVM.player.Native.AnimationAction.clipAction(
    manMixer,
    beforeAni
  )
  const afterClipAction = await romanVM.player.Native.AnimationAction.clipAction(
    manMixer,
    afterAni
  )
  // 当程序执行到此处时，需要判断是否需要停止播放所有待机动作
  // 当需要停止时，不执行播放待机动作
  if (stopExecution) {
    return
  }
  await romanVM.player.Native.AnimationAction.crossFadeFrom(
    afterClipAction,
    beforeClipAction,
    0.1,
    true
  )
}

// 循环执行任务
const executeTask = async (index) => {
  if (stopExecution) {
    return
  }
  const task = standAni[index]

  // 执行动作
  await renderAnimation(index)
  if (index === standAni.length - 1) {
    index = 0
  } else {
    index += 1
  }

  timeoutId = setTimeout(() => {
    executeTask(index)
  }, task.time)
}


const setIdle = async () => {
  stopExecution = false
  clearNextAni()
  // 停止所有动作
  const manMixer = await romanVM.player.Native.SkeletonNode.mixer(romanVM.personNode)
  await romanVM.player.Native.AnimationAction.stopActions(manMixer)
  executeTask(0)
}
/**
 * @description: 动画播放状态监听
 * @param {*} res
 * @return {*}
 */
const actionUpdate = async (res) => {
  // console.log('action res', res)
  // const personInfo = _.find(_.values(this.historyData), ['action', res.sender])
  // if (_.isEmpty(personInfo)) return
  const AnimationActionState = {
    AS_Running: 0, // 正在播放
    AS_Loop: 1, // 循环模式下，到达endTime时通知; 只要当前时间到达动画片段的结束时间,就会发出一次此通知; LM_LoopOnce, LM_LoopRepeat模式时会发送此通知
    AS_Finished: 2, // 非无线循环模式下,播放完成时通知(无限循环不存在Finished状态);LM_LoopOnce, LM_LoopRepeat, LM_LoopPingPong均有可能发送该通知
    AS_LoopPing: 3, // 乒乓模式下,时间到达开始时间时通知; LM_LoopPingPong模式时会发送此通知
    AS_LoopPong: 4, // 乒乓模式下,时间到达开始结束时间时通知; LM_LoopPingPong模式时会发送此通知
    AS_Started: 5, // 开始时通知(调用play()或者调用了间接调用play()的接口,例如 fadeIn())
    AS_Stopped: 6, // 停止时通知(调用stop()或者调用了间接调用stop()的接口,例如 fadeOut())
    AS_Paused: 7, // 暂停时通知(调用setPause(true))
    AS_Continue: 8, // 继续时通知(调用setPause(false))
  }
  if (!romanVM) return
  switch (res.state) {
    case AnimationActionState.AS_Started:
    case AnimationActionState.AS_Continue:
      break
    case AnimationActionState.AS_Finished:
      const manMixer = await romanVM.player.Native.SkeletonNode.mixer(romanVM.personNode)
      const walkClipAction = await romanVM.player.Native.AnimationAction.clipAction(manMixer, 'walk')
      await romanVM.player.Native.AnimationAction.fadeOut(walkClipAction, 0.1)
      // 小人走到了巡检点，准备走下一段路
      if (romanVM.isShowRoute) {
        await romanVM.player.Native.Route.clear()
      }
      // 展示测点面板
      // romanVM.tagCodeShow = true
      romanVM.walking = false
      romanVM.nextPoint(true)
      break
    case AnimationActionState.AS_Stopped:
    case AnimationActionState.AS_Paused:
      // {
      //   // eslint-disable-next-line no-shadow
      //   const manMixer = await romanVM.player.Native.SkeletonNode.mixer(romanVM.personNode)
      //   // eslint-disable-next-line no-shadow
      //   const idleClipAction = await romanVM.player.Native.AnimationAction.clipAction(manMixer, 'idle')
      //   // eslint-disable-next-line no-shadow
      //   const walkClipAction = await romanVM.player.Native.AnimationAction.clipAction(manMixer, 'walk')
      //   await romanVM.player.Native.AnimationAction.crossFadeFrom(
      //     idleClipAction,
      //     walkClipAction,
      //     0.2,
      //     true
      //   )
      // }
      break
    default:
      break
  }
}
// 根据距离，计算两点相隔时间, factor为系数
const computeTime = (a, b, f) => {
  const fir = (a.xPoint - b.xPoint) * (a.xPoint - b.xPoint) * f.x
  const sec = (a.yPoint - b.yPoint) * (a.yPoint - b.yPoint) * f.y
  const thr = (a.zPoint - b.zPoint) * (a.zPoint - b.zPoint) * f.z
  const dis = Math.sqrt(fir + sec + thr)
  return Math.ceil(dis)
}
// 给每一个点加上时间戳
// 根据两点的距离，可以计算出相隔的时间
// factor有三个属性，可根据不同地图的缩放调整
const formUnixTime = (p, factor) => {
  for (let i = 0; i < p.length; i += 1) {
    let startTime = 0
    if (p[i].items.length) {
      for (let j = 0; j < p[i].items.length; j += 1) {
        if (j === 0) {
          p[i].items[j].UnixTime = 0
        } else {
          const t = computeTime(p[i].items[j], p[i].items[j - 1], factor)
          startTime = startTime + t
          p[i].items[j].UnixTime = startTime
        }
      }
    }
  }
  return p
}
// 根据原始数据，两个巡检点之间取一个数据
const formOrgp = (d) => {
  const res = []
  _.forEach(d, (el) => {
    const arr = el.items
    let temp = []
    let toFinish = false
    for (let i = 0; i < arr.length; i += 1) {
      temp.push(arr[i])
      if (arr[i].inspectPointId !== null) {
        if (toFinish) {
          res.push(temp)
          temp = []
          temp.push(arr[i])
        } else {
          toFinish = true
        }
      }
    }
  })
  return res
}
// 把mixertime给从0开始递增
const formOrgpMixerTime = (data) => {
  const d = []
  _.forEach(data, (el) => {
    const beginTime = el[0].UnixTime
    const temp = []
    for (let i = 0; i < el.length; i += 1) {
      const obj = {
        UnixTime: el[i].UnixTime - beginTime,
        xPoint: el[i].xPoint,
        yPoint: el[i].yPoint,
        zPoint: el[i].zPoint,
      }
      temp.push(obj)
    }
    d.push(temp)
  })
  return d
}
// 创建人物Node，并绑定到整个模型中
const createPersonNode = async () => {
  romanVM.personNode = await romanVM.player.Native.SkeletonNode.cloneSkeletonNodeFromSystem(false)
  // romanVM.personNode = await romanVM.player.Native.SkeletonNode.loadSkeletonNode(`${romanVM.staticFilePath}/avatar/avatar.fbxSkeleton`)
  // 将模型设置为小人的父节点
  const root = await romanVM.player.Native.ModelTree.getRootItems()
  await romanVM.player.Native.NodeProxy.setNodeParent(romanVM.personNode, root[0].nodePtr)
  // 调试时将相机移动到小人面前
  // const aabb = await romanVM.player.Native.NodeProxy.getAabb(personNode)
  // romanVM.player.Native.Camera.moveToAabbWithFace(aabb, 2, 1)
  await romanVM.player.Native.NodeProxy.setNodeVisible(romanVM.personNode, true)
}
// 创建动画混合器
const createMixer = async () => {
  romanVM.mixer = await romanVM.player.Native.AnimationMixer.getMixer('person')
  // romanVM.mixer = await romanVM.player.Native.AnimationMixer.getMixer(`${romanVM.personNode}`) // 可以尝试使用小人node来作为mixername
  // const mixerTime = await romanVM.player.Native.AnimationMixer.time(mixer)
  romanVM.player.Native.AnimationMixer.setPause(romanVM.mixer, true)
  romanVM.player.Native.AnimationAction.EventActionUpdate.connect(actionUpdate)
}
/**
 * 用route来设置控制点和画线
 * 用skeletonNode 加载人物和动作
 * 用animation来创建和控制动画
 * 用orgp来实现一组数据画线
 * 将orgp按照巡检点分开，两个巡检
 */
const setRamenNew = async (p) => {
  const factor = romanVM.modelSetting.personSpeed || { x: 1, y: 1, z: 1 }
  // 根据距离，加上时间戳，距离越长，间隔越长
  const orgP = formUnixTime(p, factor)
  // 创建人物对象,这里只创建一个小人
  // await createPersonNode()
  // 创建路径动画混合器，并暂时设置为暂停
  await createMixer()
  // 判断当前混合器是否被暂停，如果暂停了就不用暂停
  const bool = await romanVM.player.Native.AnimationMixer.isPause(romanVM.mixer)
  if (!bool) {
    // eslint-disable-next-line no-await-in-loop
    await romanVM.player.Native.AnimationMixer.setPause(romanVM.mixer, true)
  }
  // 让小人站住
  const Mixer = await romanVM.player.Native.SkeletonNode.mixer(romanVM.personNode)
  const idleClipAction = await romanVM.player.Native.AnimationAction.clipAction(Mixer, 'idle')
  await romanVM.player.Native.AnimationAction.fadeIn(idleClipAction, 1.0)
  // 处理原始数据
  const t = formOrgp(orgP)
  romanVM.ranmenRouteList = formOrgpMixerTime(t)
  await romanVM.player.Native.AnimationMixer.setTime(romanVM.mixer, 0)
  // await romanVM.player.Native.AnimationMixer.bindMixerNoticeCurrentTime(romanVM.mixer)
}

/**
 * 如果inspectPointId是null的，返回null，如果是不匹配的，说明playlist中没有加入，也设置成null
 * @param {arr} inspectPointId id
 * @param {arr} inspectPoints 巡检点列表
 */
const matchRoute = (inspectPointId, inspectPoints) => {
  if (inspectPointId === null) { // 原本就不匹配的
    return null
  }
  const index = _.findIndex(inspectPoints, (o) => {
    return o.id === inspectPointId
  })
  if (index === -1) { // 未匹配
    return null
  }
  return inspectPointId
}
// 掐头去尾
const cutRoute = (items) => {
  // 头
  const headIndex = _.findIndex(items, (o) => {
    return o.inspectPointId !== null
  })
  if (headIndex === -1) {
    // console.log('头部处数据出错')
  } else {
    items = items.slice(headIndex)
  }
  // 尾
  const tailIndex = _.findLastIndex(items, (o) => {
    return o.inspectPointId !== null
  })
  if (tailIndex === -1) {
    // console.log('尾部处数据出错')
  } else if (tailIndex - items.length + 1 !== 0) {
    items = items.slice(0, tailIndex - items.length + 1)
  }
  return items
}
// 传入的巡检点处理
const compRamenRoute = (ramenPointTemp) => {
  ramenPointTemp.forEach((obj) => {
    // 去掉没匹配的
    obj.items.forEach((point) => {
      point.inspectPointId = matchRoute(point.inspectPointId, obj.inspectPoints)
    })
    // 掐头去尾
    obj.items = cutRoute(obj.items)
  })
  return ramenPointTemp
}

export {
  createPersonNode,
  setRamenNew,
  actionUpdate,
  mountVm,
  compRamenRoute,
  initIdleAniInfo,
  setIdle,
  destroyIdleAniInfo,
  clearNextAni,
  destroyVm,
}
